import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Pricing from "@/components/site/Pricing";
import Branches from "@/components/site/Branches";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Gallery />
      <Services />
      <Pricing />
      <Branches />
      <Booking />
      <Footer />
    </main>
  );
}
